import { ReactElement } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import InitSession from '../session/InitSession';
import Routes from './routes';
import { sessionThunks } from './session';
import { connectStoreToNetwork, store } from './appReducer';
import Toast from '@root/src/app/designSystem/toastNotification/toast';
import {
  FeatureFlagHealthcheckI,
  featureFlagHealthcheckSlice,
} from '../featureFlagHealthcheck';

const HealthCheck: React.FC<FeatureFlagHealthcheckI> = (
  featureFlagHealthcheck
): ReactElement => {
  connectStoreToNetwork();

  store.dispatch(
    featureFlagHealthcheckSlice.actions.init(featureFlagHealthcheck)
  );
  const googleAnalyticsFunctionality = store.getState().featureFlag
    .googleAnalyticsFunctionality;

  const googleAnalytics = () => {
    const dataLayer = window.dataLayer || [];

    const gTag = (argOne: string, argTwo: string | Date) => {
      dataLayer.push(argOne, argTwo);
    };
    gTag('js', new Date());
    gTag('config', 'G-1Z17VNZ06G');
  };

  return (
    <>
      <BrowserRouter>
        <Provider store={store}>
          <InitSession sessionThunks={sessionThunks} />
          <Routes />
        </Provider>
      </BrowserRouter>
      <Toast />
      {googleAnalyticsFunctionality && (
        <>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-1Z17VNZ06G"
          ></script>
          {googleAnalytics()}
        </>
      )}
    </>
  );
};

export default HealthCheck;
